module.exports = __webpack_public_path__ + "img/0xf0151f528127558851b39c2cd8aa47da7418ab28.803d225c.png";